// This browser's copy of the user's theme mode, read before the first paint.
//
// The mode itself lives on the account (userprofile.config.profile.theme) and
// wins as soon as the user has loaded. Until then the app would render light
// and then switch, so a dark user saw a light flash on every reload. A wrong or
// missing value costs one flash, never more.

import { ALL_MODES, type Mode } from "../components/theme";

const THEME_MODE_KEY = "theme_mode";

export const readCachedThemeMode = (): Mode | null => {
	try {
		const stored = window.localStorage.getItem(THEME_MODE_KEY);
		return stored !== null && ALL_MODES.includes(stored) ? stored : null;
	} catch {
		// Storage can be unavailable (private window, blocked site data). The
		// app then starts light, as before.
		return null;
	}
};

export const cacheThemeMode = (mode: Mode): void => {
	try {
		window.localStorage.setItem(THEME_MODE_KEY, mode);
	} catch {
		// Same: the cache is a convenience, never a requirement.
	}
};
